<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            class="wifi-bar wifi-bar-1"
            d="M0 18.8V12.5H3.87522V18.8H0Z"
            :fill="color" />
        <path
            class="wifi-bar wifi-bar-2"
            d="M7.76056 18.8V7.25H11.6358V18.8H7.76056Z"
            :fill="color" />
        <path
            class="wifi-bar wifi-bar-3"
            d="M15.5209 18.8V2H19.3961V18.8H15.5209Z"
            :fill="color" />
    </svg>
</template>
<script>
export default {
    name: "WifiIcon",
    props: {
        color: {
            type: String,
            default: "#3A3F48",
        },
    },
};
</script>
<style lang="scss">
.blinkAnimation {
    .wifi-bar-1 {
        animation: wifiBarBlink 1.8s infinite;
        animation-delay: 0s;
    }
    
    .wifi-bar-2 {
        animation: wifiBarBlink 1.8s infinite;
        animation-delay: 0.6s;
    }
    
    .wifi-bar-3 {
        animation: wifiBarBlink 1.8s infinite;
        animation-delay: 1.2s;
    }
}

@keyframes wifiBarBlink {
    0% {
        opacity: 0.2;
    }
    16% {
        opacity: 1;
    }
    33% {
        opacity: 0.2;
    }
    100% {
        opacity: 0.2;
    }
}
</style>
